var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css_class,attrs:{"id":"alert-panel-switcher"},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('div',{staticClass:"alert-panel-switcher--info-wrapper"},[_c('icon-mdi',{attrs:{"icon":_vm.icon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }